import m from "mithril"
import { MithrilTsxComponent } from "mithril-tsx-component"
import Picker from "vanilla-picker"
import "./ColorPicker.scss"
import { cleanString } from "oj-utils"
import { Zmdi } from "oj-mithril-packages/dist/Zmdi"

export class ColorPicker extends MithrilTsxComponent<{ mobile?: boolean, value: string, oninput?: (value: string) => void, onchange?: (value: string) => void, popup?: string, alpha?: boolean, editor?: boolean }> {
  picker: Picker
  open: boolean

  view(v) {
    return <div className={cleanString("ColorPicker", v.attrs.mobile && "unsetPosition")}>
      <button className="color" onclick={e => this.picker.openHandler()}>
        <div style={{ backgroundColor: v.attrs.value }}></div>
        <span>Select color</span>
        <Zmdi icon={this.open ? "chevron-up" : "chevron-down"} />
      </button>
      <div>
      </div>
    </div>
  }

  oncreate(v) {
    this.picker = new Picker({
      parent: v.dom.children[1],
      popup: v.attrs.popup || "top",
      alpha: v.attrs.alpha || false,
      editor: v.attrs.editor || true,
      color: v.attrs.value,
      onChange: c => {
        if (v.attrs.oninput && this.open)
          v.attrs.oninput(c.rgbString)
      },
      onDone: c => {
        if (v.attrs.onchange)
          v.attrs.onchange(c.rgbString)
      },
      onOpen: () => {
        this.open = true
      },
      onClose: () => {
        this.open = false
      }
    })
  }

  onbeforeupdate(v, o) {
    if (v.attrs.value !== o.attrs.value) {
      this.picker.setColor(v.attrs.value)
    }
  }

  onremove(v) {
    this.picker.destroy()
  }
}